import React, { FC, ReactNode } from 'react';
import { Tag } from 'snacks-design-system';
import styles from './PIETag.module.scss';

/* https://snacks.takeaway.com/portal/components/tag/usage/ */

export enum ETagsColorType {
  Neutral = 'neutral',
  NeutralAlt = 'neutral-alt',
  Outline = 'outline',
  Ghost = 'ghost',
  Blue = 'blue',
  Yellow = 'yellow',
  Information = 'information',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Red = 'red',
  Brand = 'brand',
  Green = 'green',
  Brand02 = 'brand-02',
  Brand03 = 'brand-03',
  Brand04 = 'brand-04',
  Brand05 = 'brand-05',
  Brand06 = 'brand-06',
}

interface IPIETag {
  children: ReactNode;
  className: string;
  icon: ReactNode;
  mode: ETagsColorType;
  size: 'large' | 'small';
  modStrong: boolean /* making strong the colours */;
}

export const PIETag: FC<Partial<IPIETag>> = (props) => {
  return (
    <Tag {...props} className={`${props.className} ${styles.PIETag}`}>
      {props.children}
    </Tag>
  );
};

export default PIETag;
